var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "장치 및 설비 기본정보" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "custom-btn",
                                attrs: {
                                  icon: "help",
                                  color: "deep-purple-6",
                                  "text-color": "white",
                                  align: "center",
                                  round: "",
                                },
                              },
                              [
                                _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "bottom left",
                                      self: "top left",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustomTop" },
                                      [_vm._v(" (주) ")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustom" },
                                      [
                                        _vm._v(
                                          " ① 압력용기, 증류탑, 반응기, 열교환기, 탱크류 등 고정기계에 해당합니다."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " ② 부속물은 증류탑의 충진물, 데미스터(Demister), 내부의 지지물 등을 말합니다."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " ③ 용량에는 장치 및 설비의 직경 및 높이 등을 기재합니다."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " ④ 열교환기류는 동체측과 튜브측을 구별하여 기재합니다."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " ⑤ 자켓이 있는 압력용기류는 동체측과 자켓측을 구별하여 기재합니다. "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.psiDeviceEquipmentId &&
                                    !_vm.isRevision &&
                                    _vm.isEnalbed,
                                  expression:
                                    "(editable && popupParam.psiDeviceEquipmentId && !isRevision) && isEnalbed",
                                },
                              ],
                              attrs: { label: "개정", icon: "restart_alt" },
                              on: { btnClicked: _vm.SetRevision },
                            }),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.psiDeviceEquipmentId &&
                                    _vm.isRevision &&
                                    _vm.isEnalbed,
                                  expression:
                                    "(editable && popupParam.psiDeviceEquipmentId && isRevision) && isEnalbed",
                                },
                              ],
                              attrs: { label: "개정취소", icon: "restart_alt" },
                              on: { btnClicked: _vm.CancelRevision },
                            }),
                            _vm.editable && _vm.isEnalbed
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "저장",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveData,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                            _vm.editable &&
                            _vm.popupParam.psiDeviceEquipmentId &&
                            _vm.isEnalbed
                              ? _c("c-btn", {
                                  attrs: { label: "삭제", icon: "remove" },
                                  on: { btnClicked: _vm.deleteData },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "장치번호",
                              name: "equipmentNo",
                            },
                            model: {
                              value: _vm.data.equipmentNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "equipmentNo", $$v)
                              },
                              expression: "data.equipmentNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "장치명",
                              name: "deviceName",
                            },
                            model: {
                              value: _vm.data.deviceName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deviceName", $$v)
                              },
                              expression: "data.deviceName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                        },
                        [
                          _c("c-select", {
                            attrs: {
                              required: true,
                              editable:
                                _vm.editable &&
                                !_vm.popupParam.psiDeviceEquipmentId,
                              codeGroupCd: "DEVICE_TYPE_CD",
                              type: "edit",
                              itemText: "codeName",
                              itemValue: "code",
                              name: "deviceTypeCd",
                              label: "장치분류",
                            },
                            model: {
                              value: _vm.data.deviceTypeCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deviceTypeCd", $$v)
                              },
                              expression: "data.deviceTypeCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-equip", {
                            attrs: {
                              editable: _vm.editable,
                              label: "설비",
                              name: "equipmentCd",
                            },
                            model: {
                              value: _vm.data.equipmentCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "equipmentCd", $$v)
                              },
                              expression: "data.equipmentCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-process", {
                            attrs: {
                              editable: _vm.editable,
                              label: "관련공정",
                              multiple: "single",
                              name: "processCd",
                            },
                            model: {
                              value: _vm.data.processCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "processCd", $$v)
                              },
                              expression: "data.processCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                        },
                        [
                          _c("c-dept", {
                            attrs: {
                              editable: _vm.editable,
                              label: "관리부서",
                              name: "deptCd",
                            },
                            model: {
                              value: _vm.data.deptCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deptCd", $$v)
                              },
                              expression: "data.deptCd",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c("c-tab", {
                  attrs: {
                    type: "tabcard",
                    tabItems: _vm.tabItems,
                    inlineLabel: true,
                    align: "left",
                  },
                  on: {
                    "update:tabItems": function ($event) {
                      _vm.tabItems = $event
                    },
                    "update:tab-items": function ($event) {
                      _vm.tabItems = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (tab) {
                        return [
                          _c(tab.component, {
                            key: tab.tabKey,
                            tag: "component",
                            attrs: { param: tab.param, item: tab.item },
                            on: {
                              "update:item": function ($event) {
                                return _vm.$set(tab, "item", $event)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _vm.popupParam.psiDeviceEquipmentId
                  ? _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm",
                        attrs: { title: "개정", topClass: "topcolor-orange" },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "개정번호",
                                        name: "revisionNum",
                                      },
                                      model: {
                                        value: _vm.data.revisionNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "revisionNum", $$v)
                                        },
                                        expression: "data.revisionNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                                  },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "개정일시",
                                        name: "regDtStr",
                                      },
                                      model: {
                                        value: _vm.data.regDtStr,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regDtStr", $$v)
                                        },
                                        expression: "data.regDtStr",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                                  },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "개정자",
                                        name: "regUserName",
                                      },
                                      model: {
                                        value: _vm.data.regUserName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regUserName", $$v)
                                        },
                                        expression: "data.regUserName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                                  },
                                  [
                                    _c("c-moc", {
                                      attrs: {
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        isSubmit: _vm.saveCallData,
                                        document: _vm.data,
                                        documentId:
                                          _vm.popupParam.psiDeviceEquipmentId,
                                        documentTitle: "deviceName",
                                        mocRelatedTaskCd: "RT00000001",
                                        label: "MOC번호",
                                        name: "sopMocId",
                                      },
                                      on: {
                                        "update:document": function ($event) {
                                          _vm.data = $event
                                        },
                                      },
                                      model: {
                                        value: _vm.data.sopMocId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "sopMocId", $$v)
                                        },
                                        expression: "data.sopMocId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                                  },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "개정사유",
                                        name: "revisionContent",
                                      },
                                      model: {
                                        value: _vm.data.revisionContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "revisionContent",
                                            $$v
                                          )
                                        },
                                        expression: "data.revisionContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                              staticStyle: { "margin-top": "-18px !important" },
                              attrs: { id: "revdiv" },
                            },
                            [
                              _c("c-table", {
                                ref: "revision",
                                attrs: {
                                  title: "개정이력",
                                  tableId: "revision",
                                  topBorderClass: "topcolor-orange",
                                  columns: _vm.gridrev.columns,
                                  data: _vm.gridrev.data,
                                  gridHeight: "150px",
                                  columnSetting: false,
                                  expandAll: false,
                                  isFullScreen: false,
                                  usePaging: false,
                                  hideBottom: true,
                                  filtering: false,
                                },
                                on: { rowClick: _vm.rowClickRev },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }